(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/FormatMapView2',["jquery", "backbone", "underscore", "hbs!pricelist/templates/formatMap2"], function($, Backbone, _, formatMapHbs) {
    var View;
    return View = (function(superClass) {
      extend(View, superClass);

      function View() {
        this.render = bind(this.render, this);
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.el = "#formatmapsection";

      View.prototype.events = {
        "change .formatMap-select": "onChangeFormatMap"
      };

      View.prototype.render = function() {
        var $image, apiImage, currentPriceId, currentPriceInfo, priceTechnicals;
        currentPriceId = this.model.get("selectedPriceId");
        priceTechnicals = this.model.get("PriceTechnicals");
        currentPriceInfo = priceTechnicals.find(function(x) {
          return x.PriceId.toString() === currentPriceId;
        });
        this.$el.html(formatMapHbs({
          info: currentPriceInfo
        }));
        $image = $("#formatMapImage").first();
        apiImage = new Image();
        apiImage.onload = function() {
          $image.attr("src", apiImage.src);
          return $("#formatMapLoading").remove();
        };
        apiImage.onerror = function() {
          return $("#formatMapImage").remove();
        };
        return apiImage.src = TSUrl.ApiUrl + "/Api/Pictures/AdFormat?priceId=" + currentPriceId + "&width=200&height=200";
      };

      View.prototype.onChangeFormatMap = function(event) {};

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=formatMapView2.js.map
;
